module.exports = __webpack_public_path__ + "static/media/chat-icon-square.7eff9f56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat-icon-square.svg
// module id = 684
// module chunks = 0